import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="bg-white px-4 py-5 sm:px-6" data-id="element-156" data-mp="3kqw54mwtl6h6">
      <div className="mx-auto max-w-2xl" data-id="element-157" data-mp="3fze45yusr5w7">
        <h2 className="text-center font-heading text-lg font-extrabold uppercase text-deep sm:text-3xl" data-id="element-158" data-mp="3fy2z7vpm7s3i">
          Professionals using the system
        </h2>
        <div className="mt-3 space-y-2.5" data-id="element-159" data-mp="36zilza2tqamo">
          {testimonials.map(t => <figure key={t.name} className="rounded-xl border border-clinical/15 bg-ice p-3 shadow-sm" data-id="element-160" data-mp="31zwb37agx6h1">
              <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-161" data-mp="2x1kyiossghv4">
                {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-4 w-4 fill-turq text-turq" aria-hidden="true" data-id="element-162" data-mp="2s3jfu4z9ykk6" />)}
              </div>
              <blockquote className="mt-1 text-[0.86rem] leading-snug text-ink sm:text-base" data-id="element-163" data-mp="q8iv1jksborv">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-1.5 font-heading text-[0.72rem] font-bold uppercase text-deep sm:text-sm" data-id="element-164" data-mp="m62pk5tiw9ud">
                {t.name}
                <span className="block font-body text-[0.7rem] font-medium normal-case text-muted sm:text-xs" data-id="element-165" data-mp="79v7bb1odihq">
                  {t.role} · {t.location}
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}